var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-radio-box" },
    [
      _vm.label
        ? _c("h3", { class: { "required-field": _vm.isRequired } }, [
            _vm._v("\n    " + _vm._s(_vm.label)),
            _vm.onRequired ? _c("span", [_vm._v(_vm._s("*"))]) : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-radio-group",
        {
          staticClass: "mb-0",
          attrs: {
            value: _vm.value,
            row: _vm.row,
            disabled: _vm.disabled,
            "persistent-hint": _vm.persistentHint,
            hint: _vm.hint,
            "error-messages": _vm.$formErrors(_vm.v),
          },
          on: { change: _vm.change },
        },
        _vm._l(_vm.options, function (option, index) {
          return _c("v-radio", {
            key: index,
            attrs: {
              label: option[_vm.onLabel],
              value: option[_vm.onValue],
              disabled: option.disabled,
              color: "secondary",
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }